import React from "react";
import "./Showcase.scss";
import { H3 } from "../../ui/Typography";
import { Accordion, AccordionItem, AccordionTitle, Button } from "../../ui";

function ShowcaseAccordion() {
  return (
    <>
      <div className="showcase-wrapper">
        <H3>(Textbox 1) Outline Textbox , 2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S) h28px w166px</th>
                <th>(M)h 36 Px font 16px</th>
                <th>(XL)h 48px font 20px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Accordion size="sm">
                    <AccordionItem>
                      <AccordionTitle>IPV6</AccordionTitle>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s,
                      <Button>hello world</Button>
                    </AccordionItem>
                  </Accordion>
                </td>
                <td>
                  <Accordion size="md">
                    <AccordionItem>
                      <AccordionTitle>IPV6</AccordionTitle>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s,
                      <Button>hello world</Button>
                    </AccordionItem>
                  </Accordion>
                </td>
                <td>
                  <Accordion size="lg">
                    <AccordionItem>
                      <AccordionTitle>IPV6</AccordionTitle>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s,
                      <Button>hello world</Button>
                    </AccordionItem>
                  </Accordion>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShowcaseAccordion;
